/**
 * The current Genie conversation's thread id
 * Genie writes it; other features (e.g. feedback) read it
 */
const GENIE_THREAD_ID_KEY = "kms-genie-thread-id";

export const setGenieThreadId = (threadId: string) => {
    try {
        window.sessionStorage.setItem(GENIE_THREAD_ID_KEY, threadId);
    }
    catch {
        // storage unavailable (e.g. blocked site data) - the thread id just isn't kept
    }
};

/** the current Genie thread id, undefined when there is none (or storage is unavailable) */
export const getGenieThreadId = (): string | undefined => {
    try {
        return window.sessionStorage.getItem(GENIE_THREAD_ID_KEY) || undefined;
    }
    catch {
        return undefined;
    }
};
